/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteWorkspaceResponse } from '../../models/delete-workspace-response';

export interface DeleteWorkspace$Params {
  workspaceId: number;
}

export function deleteWorkspace(http: HttpClient, rootUrl: string, params: DeleteWorkspace$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteWorkspaceResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteWorkspace.PATH, 'delete');
  if (params) {
    rb.path('workspaceId', params.workspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteWorkspaceResponse>;
    })
  );
}

deleteWorkspace.PATH = '/workspaces/{workspaceId}';
